<span
  [coreCustomTooltip]="tooltip()"
  class="badge"
  [class]="'badge-' + severity() + ' ' + class()"
  >{{ text() }}</span
>
